export default __webpack_public_path__ + "static/media/scissors.37b72d07.svg";